<template>
  <div class="wrap">
    <template v-for="(group, groupKey) in pagesList">
      <div v-if="group.filter((i) => checkShowButton(i)).length" class="wrap_box" :key="groupKey">
        <v-container class="inner-container">
          <template v-for="(page, pageKey) in group">
            <AllSettingItem
              v-if="checkShowButton(page)"
              :key="'gpoup_' + groupKey + '-page_' + pageKey"
              :toName="page.toName"
              :icon="page.icon"
              :text="page.text"
              :customClass="'line' + (groupKey + 1)"
            />
          </template>
        </v-container>
      </div>
    </template>
  </div>
</template>

<script>
import AllSettingItem from 'components/setting/AllSettingItem'
import pages_config from '~/configs/pages'

export default {
  name: 'AllSetting',
  
  data() {
    return {
      host: location.host,
    }
  },
  components: {
    AllSettingItem,
  },
  computed: {
    pagesList() {
      const conf = pages_config({})
      return conf && conf['setting'].pages
    },
  },
  methods: {
    checkShowButton(item) {
      return (
        (item.access !== undefined ? item.access : true) &&
        (item.hidden !== undefined ? this.$vuetify.breakpoint.width > item.hidden : true)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  &_box {
    padding: 24px 0px;
    &:not(:last-of-type) {
      border-bottom: 1px solid #6ab1d8;
    }
    &.hidden {
      display: none;
    }
    .inner-container {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      grid-gap: 20px;
    }
  }
}
</style>
